module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_vis-4d19fe8635db421273246d85034d3573.jpg";